import {
	MappingEventStatistiques
} from '../../configs/mapping-event-statistiques.enum';

/**
 * Le suffixe de la clé statistique liée à chaque valeur du champ combienEnfants
 */
export enum StatistiquesChampCombienSalaire {
	'smic1' = 'smic1',
	'smic2' = 'smic2',
	'smic3' = 'smic3',
	'smic4' = 'smic4',
	'smic5' = 'smic5',
	'smic6' = 'smic6',
	'smic7' = 'smic7'
}

/**
 * Le suffixe de la clé statistique liée à chaque valeur du champ combienEnfants
 */
export enum StatistiquesChampCombienEnfants {
	'aucunEnfant' = 'aucun',
	'1Enfant' = '1',
	'2Enfants' = '2',
	'3Enfants' = '3',
	'4+Enfants' = '4'
}

export const ORGANISMES: Record<string, { libelle: string, libelleComplement: string, url: string,
	stat: MappingEventStatistiques }> = {
		caf: {
			libelle: 'CAF',
			libelleComplement: ' (créez un compte si besoin)',
			url: 'https://wwwd.caf.fr/redirect/s/Redirect?page=monCompteDemanderLAVVC',
			stat: MappingEventStatistiques.clicChampOrganismeCaf
		},
		autre: {
			libelle: 'CAF',
			libelleComplement: ' (créez un compte si besoin)',
			url: 'https://wwwd.caf.fr/redirect/s/Redirect?page=monCompteDemanderLAVVC',
			stat: MappingEventStatistiques.clicChampOrganismeAutre
		},
		msa: {
			libelle: 'MSA',
			libelleComplement: '',
			url: 'https://www.msa.fr/famille/aide-urgence-victimes-violences-conjugales',
			stat: MappingEventStatistiques.clicChampOrganismeMsa
		}
	};
